import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location){ return originalPush.call(this, location).catch(e => e) }

const routes = [
  { path:'/', component: () => import('@/views/Home.vue') },
  { path: '/home', redirect: '/' },
  { path: '/goods/all', component: () => import('@/views/ProductList.vue') },
  { path: '/goods/:id', component: () => import('@/views/ProductDetail.vue') },
  { path: '/cart', component: () => import('@/views/Cart.vue') },
  { path: '/login', component: () => import('@/views/Auth.vue') },
  { path: '/return-policy', component: () => import('@/views/ReturnPolicy.vue') },
  { path: '/guest-security', component: () => import('@/views/GuestSecurity.vue') },
  { path: '/legal-privacy', component: () => import('@/views/LegalPrivacy.vue') },
  { path: '/register', redirect: '/login' },
  { path: '*', redirect: '/' }
]
export default new VueRouter({ 
  mode:'history', 
  base:process.env.BASE_URL, 
  routes, 
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
